export default __webpack_public_path__ + "static/media/gallary6.43816d03.jpg";